/**
 * Route definition for /chains/avalanche
 *
 * Renders the shared ChainPage with the `avalanche` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/avalanche
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/avalanche')({
  component: function AvalancheChainPage() {
    return <ChainPage slug="avalanche" />
  },
})
